(function(){

  var resizeTimer = null;
  var els         = document.querySelectorAll('.js-set-fixed-bg-height');
  var ratio       = 540 / 1600; // This is the 1x image's height divided by its width.

  function setFixedBgHeight() {
    var vpWidth = document.documentElement.clientWidth;

    if (vpWidth >= 861) {
      var headerHeight  = document.querySelector('.site-header').offsetHeight;
      var desiredHeight = (vpWidth * ratio) - headerHeight;

      Array.prototype.forEach.call(els, function(el) {
        el.style.height = (desiredHeight - 1) + 'px';
      });
    }
  }

  window.onload = setFixedBgHeight;

  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      setFixedBgHeight();
    }, 250);
  });

})();
